// Pollyfills for IE and edge
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "fast-text-encoding";

import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";

import configureStore from "./store/store";
import "antd/dist/antd.less";
import "./locales/i18n";
import { MainRouter } from "./router/MainRouter";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./component/ErrorFallback";

require("typeface-open-sans");

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);

ReactDOM.render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <ReduxProvider store={reduxStore}>
      <MainRouter />
    </ReduxProvider>
  </ErrorBoundary>,
  document.getElementById("root")
);
